import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfManitoba = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Manitoba"
      universityShortName="U of M"
      slug="university-of-manitoba"
      seoTitle="University of Manitoba Study Rooms | Winnipeg Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Manitoba. Find Elizabeth Dafoe Library, Quiet Pods, and group study spaces. Plus free 24/7 online alternative."
      seoKeywords="university of manitoba study rooms, umanitoba library, elizabeth dafoe library, winnipeg university study spaces, quiet pods"
      canonicalUrl="/study-room/university-of-manitoba/"
      heroDescription="A comprehensive guide to study rooms at U of M, including Elizabeth Dafoe Library and the new Quiet Pods."
      libraryWebsiteUrl="https://umanitoba.ca/libraries/"
      libraryWebsiteName="U of M Libraries"
      studySpaces={[
        {
          name: "Elizabeth Dafoe Library - Group Study Rooms",
          features: "Three bookable group study rooms with a two-hour limit.",
          feedback: "Dafoe becomes crowded; booking in advance is essential."
        },
        {
          name: "Group Areas Near Starbucks",
          features: "Additional group seating near the in-library Starbucks.",
          feedback: "Convenient for caffeine but can be noisy."
        },
        {
          name: "Quiet Pods",
          features: "Recently upgraded pods for virtual meetings and exams; bookable for up to three hours.",
          feedback: "Created in response to crowding; offer private space for calls."
        },
        {
          name: "Second and Third Floor Quiet Zones",
          features: "Quiet study zones on upper floors.",
          feedback: "Popular for their outlets; mezzanine and third floor carrels fill quickly."
        },
        {
          name: "Graduate and President's Scholar Study Rooms",
          features: "Long-term reservable rooms for graduate students and President's Scholars.",
          feedback: "Exclusive spaces highly valued by eligible students."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Book group rooms early and take advantage of the <strong>Quiet Pods</strong> if you need a private spot. For silent study, head to the <strong>second or third floors</strong>.
          </p>
          <p className="mb-4">
            Remember that the <strong>Center for Newfoundland Studies reading room</strong> (third floor) prohibits food and drink.
          </p>
          <p>
            Students say Dafoe becomes crowded, prompting the creation of Quiet Pods to provide more private study options.
          </p>
        </>
      }
      summaryTips={[
        "Book group rooms early: Only three rooms available with two-hour limits.",
        "Use the Quiet Pods: Perfect for virtual meetings and exams; book up to three hours.",
        "Head to upper floors for quiet: Second and third floors offer quieter atmospheres.",
        "Graduate students: Apply for long-term study room access.",
        "Use CSW for unlimited study time: No two-hour limits in virtual study rooms."
      ]}
    />
  );
};

export default UniversityOfManitoba;
